import { render, staticRenderFns } from "./feedback.html?vue&type=template&id=2295af7a&"
import script from "./feedback.ts?vue&type=script&lang=ts&"
export * from "./feedback.ts?vue&type=script&lang=ts&"
import style0 from "./feedback.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports